var _defs, _g, _polygon, _path, _polygon2, _path2, _polygon3, _polygon4, _path3, _path4, _path5, _path6, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsRoomWidthRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.88 142.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ea8b77;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#59595b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 190.33,
    y1: 10.69,
    x2: 225.88,
    y2: 10.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db7860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed7159"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.01,
    y1: 65.28,
    x2: 216.07,
    y2: 65.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5999.04,
    y1: -2657.91,
    x2: -5963.5,
    y2: -2657.91,
    gradientTransform: "translate(-5963.34 -2538.62) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "200.12 5.9 199.96 18.58 190.25 12.68 190.41 0 200.12 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "190.33 0 225.88 0.36 225.76 21.37 213.19 13.79 202.9 7.58 190.33 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "225.76 21.37 225.8 34.06 215.91 28.16 216.07 15.48 225.76 21.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "200.14 5.9 216.07 15.48 26.94 124.67 11.01 115.09 200.14 5.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "216.07 15.48 215.91 28.16 27.5 137.36 26.94 124.67 216.07 15.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.7 129.97 35.7 142.96 0 142.3 0.16 129.62 35.7 129.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.7 129.97 0.16 129.62 0.27 108.6 12.85 116.18 23.13 122.39 35.7 129.97"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "51.01 63.86 49.44 64.77 46.82 63.47 46.82 63.38 48.96 62.15 50.23 62.84 51.48 60.7 53.61 59.47 53.61 59.58 51.01 63.86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50.66,71a5,5,0,0,1,3.23,0,2.33,2.33,0,0,1,1,2.24,6.24,6.24,0,0,1-1.22,3.65,10,10,0,0,1-3.32,3,6.29,6.29,0,0,1-2.64.92,2.11,2.11,0,0,1-1.82-.62,3.06,3.06,0,0,1-.63-2.1l2.6-1.5q0,2.39,2.49,1a4.45,4.45,0,0,0,1.43-1.27,2.43,2.43,0,0,0,.51-1.5c0-.56-.17-.89-.52-1a4.38,4.38,0,0,0-1.86.12,9.07,9.07,0,0,1-2.13.24,2,2,0,0,1-2.15-2.34,5.76,5.76,0,0,1,.57-2.41A8.44,8.44,0,0,1,47.85,67a10.79,10.79,0,0,1,2.41-1.91,5.39,5.39,0,0,1,2.4-.82,1.89,1.89,0,0,1,1.64.64,3,3,0,0,1,.59,2L52.3,68.37c0-.66-.19-1.07-.55-1.23a1.83,1.83,0,0,0-1.53.34,4.38,4.38,0,0,0-1.47,1.31,2.54,2.54,0,0,0-.52,1.52.72.72,0,0,0,.62.82A4.6,4.6,0,0,0,50.66,71Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "59.38 60.02 59.41 74.45 56.83 75.94 56.79 61.51 59.38 60.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.86,63l2.74,4.33v.14L68.82,69,66.45,65.1l-2.06,1.19v5.28l-2.58,1.49,0-14.43,4.66-2.69c1.48-.86,2.63-1.14,3.43-.85s1.22,1.14,1.22,2.53a7,7,0,0,1-.55,2.78A9.06,9.06,0,0,1,68.86,63ZM68,61.23a3.41,3.41,0,0,0,.53-1.88c0-.68-.16-1.12-.5-1.31s-.85-.1-1.55.3l-2.08,1.21v4.33l2.09-1.2A4.1,4.1,0,0,0,68,61.23"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.8 50.54 75.84 64.97 73.25 66.46 73.21 52.03 75.8 50.54"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.41 43.26 88.45 57.69 85.86 59.18 80.8 52.59 80.82 62.09 78.24 63.58 78.2 49.15 80.78 47.66 85.86 54.26 85.83 44.74 88.41 43.26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.83,38.39l4.75,11.71-2.75,1.59-.89-2.46-4.53,2.61-.86,3.48L89.8,56.91l4.64-17.14ZM94.1,49l3.14-1.81-1.59-4.49L94.1,49"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.6,29.67a5.55,5.55,0,0,1,2.4-.83,1.91,1.91,0,0,1,1.64.64,3,3,0,0,1,.59,2L113.64,33c0-.65-.19-1.06-.55-1.22a1.78,1.78,0,0,0-1.53.33,4.4,4.4,0,0,0-1.47,1.32,2.65,2.65,0,0,0-.52,1.51.73.73,0,0,0,.62.82,4.65,4.65,0,0,0,1.82-.16,4.92,4.92,0,0,1,3.22,0,2.34,2.34,0,0,1,1,2.23A6.36,6.36,0,0,1,115,41.48a10.19,10.19,0,0,1-3.31,3,6.2,6.2,0,0,1-2.65.91,2.12,2.12,0,0,1-1.82-.62,3.12,3.12,0,0,1-.63-2.1l2.6-1.5c0,1.59.83,1.92,2.49,1a4.58,4.58,0,0,0,1.44-1.26,2.61,2.61,0,0,0,.51-1.5c0-.57-.18-.9-.52-1a4.47,4.47,0,0,0-1.87.13,9.41,9.41,0,0,1-2.13.23A2,2,0,0,1,107,36.37a5.8,5.8,0,0,1,.57-2.41,8.8,8.8,0,0,1,1.64-2.39A10.47,10.47,0,0,1,111.6,29.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.62,23.77a7.07,7.07,0,0,1,.68,3.36v.64a12.92,12.92,0,0,1-.65,4.12,11.75,11.75,0,0,1-1.87,3.56,9.54,9.54,0,0,1-2.8,2.49,4.54,4.54,0,0,1-2.78.75,2.52,2.52,0,0,1-1.91-1.37,6.91,6.91,0,0,1-.69-3.29v-.71a13.47,13.47,0,0,1,.65-4.14,12.12,12.12,0,0,1,1.89-3.58,9.69,9.69,0,0,1,2.78-2.48,4.53,4.53,0,0,1,2.8-.74A2.48,2.48,0,0,1,127.62,23.77Zm-1.94,5.57v-.7a4.61,4.61,0,0,0-.72-3c-.47-.52-1.15-.52-2,0a4.82,4.82,0,0,0-2,2.33,9.3,9.3,0,0,0-.71,3.82v.71a4.62,4.62,0,0,0,.72,3c.47.55,1.15.57,2,0a4.82,4.82,0,0,0,2-2.32,9.44,9.44,0,0,0,.7-3.84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M139,22.21a2.26,2.26,0,0,1,.56,1.74,6.61,6.61,0,0,1-1.14,3.81,9.8,9.8,0,0,1-3.29,3l-4.89,2.82,0-14.43,4.4-2.54c1.53-.88,2.68-1.21,3.47-1s1.19,1,1.2,2.27a5.26,5.26,0,0,1-.48,2.14A6.33,6.33,0,0,1,137.44,22,1.49,1.49,0,0,1,139,22.21Zm-2.53,4.88a3.06,3.06,0,0,0,.51-1.68c0-1.32-.6-1.65-1.79-1l-2.37,1.37v3.89L135,28.41a4.06,4.06,0,0,0,1.43-1.32m-3.67-7V23.7l1.92-1.11a3.35,3.35,0,0,0,1.94-2.92c0-.66-.16-1-.49-1.13a2.33,2.33,0,0,0-1.57.48l-1.81,1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "149.84 7.79 149.85 10.2 144.03 13.55 144.04 16.99 149.01 14.12 149.02 16.43 144.04 19.3 144.06 23.18 149.89 19.82 149.9 22.21 141.48 27.07 141.44 12.64 149.84 7.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsRoomWidthRed);
export default __webpack_public_path__ + "static/media/rs-room-width-red.6d90d4ff6fd6a25a96c1ae0203c230d8.svg";
export { ForwardRef as ReactComponent };